import { Flex } from '@chakra-ui/react';
import { NodeViewWrapper, NodeViewContent } from '@tiptap/react';

const CodeBlockComponent = (props) => {
  const nodeContent = props.node?.textContent;
  const lines = nodeContent.split('\n');
  const lineCount = lines.length;

  return (
    <NodeViewWrapper className="code-block" style={{ position: 'relative' }}>
      {/* Line numbers column */}
      <Flex className="line-numbers" direction="column" alignItems="flex-end" userSelect="none">
        {Array.from({ length: lineCount }, (_, i) => (
          <div key={i}>{i + 1}</div>
        ))}
      </Flex>

      {/* Editable code area */}
      <pre>
        <NodeViewContent as="code" />
      </pre>
    </NodeViewWrapper>
  );
};

export default CodeBlockComponent;
